// @flow

import React, { createContext, useContext, useState } from 'react';
import { translations, type Language } from './translations';

type LanguageContextType = {
    language: Language,
    setLanguage: (lang: Language) => void,
    t: (key: string) => string,
};

const LanguageContext = createContext<LanguageContextType | null>(null);

export const LanguageProvider = ({ children }: { children: React$Node }): React$Node => {
    const [language, setLanguage] = useState<Language>('en');

    const t = (key: string): string => {
        return translations[language]?.[key] || translations.en[key] || key;
    };

    return (
        <LanguageContext.Provider value={{ language, setLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = (): LanguageContextType => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};
